// extracted by mini-css-extract-plugin
export default {"dotDarkGreen":"#407c04","dotLightGreen":"#f1f7e3","dotBrandBlue":"#0082ca","dotDarkBlue":"#00426b"};